import { useContactSubmissionProjectParams } from "app/frontend/components/contact/useContactSubmissionProjectParams";
import { EProjectTypes } from "app/frontend/constants/enums";
import { useParamsProjectType } from "app/frontend/hooks/project/useParamsProjectType";

export const useIsMHD = () => {
    const contactParams = useContactSubmissionProjectParams();
    const projecType = useParamsProjectType() || contactParams?.project_type;
    return projecType === EProjectTypes.MHD;
};
